import { BellOutline } from 'antd-mobile-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDriverReminderUnread } from '../hooks/useDriverReminderUnread';

type ReminderHeaderBellVariant = 'onPrimary' | 'onLight';

interface ReminderHeaderBellProps {
  /** Hall header sits on primary blue; page headers are light. */
  variant?: ReminderHeaderBellVariant;
}

/** Header bell + unread count — only rendered when there are unread reminders. */
function ReminderHeaderBell({ variant = 'onLight' }: ReminderHeaderBellProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const count = useDriverReminderUnread();

  if (count <= 0) return null;

  const label = t('reminders.headerBell', { count });

  return (
    <button
      type="button"
      className={`driver-reminder-bell driver-reminder-bell--${variant}`}
      onClick={() => navigate('/reminders')}
      aria-label={label}
      title={label}
    >
      <BellOutline fontSize={20} />
      <span className="driver-reminder-bell__count">{count > 99 ? '99+' : count}</span>
    </button>
  );
}

export default ReminderHeaderBell;
